import { useSelectedApPayee } from '@/components/ApPayee/useChangeApPayee';
import { useTranslation } from '@/i18n';
import {
  CaptionProps,
  Radio,
  RadioProps,
} from '@moneyforward/ap-frontend-components';
import { RadioChangeEvent } from 'antd';
import { ApPayeeDetail } from 'ap-openapi';
import { FC, memo, useCallback, useMemo } from 'react';
import { SelectedType } from '../type';

export type Props = {
  onChange: (value: SelectedType, args?: ApPayeeDetail | undefined) => void;
  defaultValue?: SelectedType;
};

export const ApPayee: FC<Props> = memo(({ onChange, defaultValue }) => {
  const selectedApPayee = useSelectedApPayee();
  const onChangeRadio = useCallback(
    (e: RadioChangeEvent) => {
      onChange(e.target.value, selectedApPayee);
    },
    [onChange, selectedApPayee]
  );
  const { t } = useTranslation();
  const caption: CaptionProps = useMemo(
    () => ({
      type: 'helper',
      icon: false,
      children: (
        <div>
          <div>{t('invoice_reports.ap_payee.radio_overwrite_sub_helper')}</div>
          <div>
            {t(
              'invoice_reports.ap_payee.radio_overwrite_sub_helper.foreign_currency'
            )}
          </div>
        </div>
      ),
    }),
    [t]
  );
  const options: RadioProps['options'] = [
    {
      testId: 'apPayee-all',
      id: 'apPayee-all',
      value: 'all',
      label: t('invoice_reports.ap_payee.radio_overwrite_sub'),
      caption,
    },
    {
      testId: 'apPayee-only',
      id: 'apPayee-only',
      value: 'only',
      label: t('invoice_reports.ap_payee.radio_not_overwrite'),
    },
  ];
  return (
    <Radio
      vertical
      onChange={onChangeRadio}
      options={options}
      testId='apPayee'
      defaultValue={defaultValue}
    />
  );
});
ApPayee.displayName = 'ApPayee';
